<template>
  <div>
    <template v-if="setting.layout.value === 'side'">
      <Layout key="side" :class="mainLayoutCls">
        <Aside><layout-side-nav /></Aside>
        <Layout>
          <Header><LayoutHeader /></Header>
          <Content><LayoutContent /></Content>
        </Layout>
      </Layout>
    </template>

    <template v-else>
      <Layout key="no-side">
        <Header><layout-header /> </Header>
        <Layout :class="mainLayoutCls">
          <layout-side-nav />
          <layout-content />
        </Layout>
      </Layout>
    </template>
    <SettingCom />
  </div>
</template>

<script setup lang="ts">
import '@/style/layout.less';

import { storeToRefs } from 'pinia';
import { Aside, Content, Header, Layout } from 'tdesign-vue-next';
import { computed, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';

import { prefix } from '@/config/global';
import LayoutSideNav from '@/layouts/components/layout-side-nav.vue';
import LayoutContent from '@/layouts/components/LayoutContent.vue';
import LayoutHeader from '@/layouts/components/LayoutHeader.vue';
import SettingCom from '@/layouts/setting-layout.vue';
import { useSettingStore, useTabsRouterStore } from '@/store';

defineOptions({
  name: 'DefaultLayout',
});

const route = useRoute();
const settingStore = useSettingStore();
const tabsRouterStore = useTabsRouterStore();
const setting = storeToRefs(settingStore);

const mainLayoutCls = computed(() => [
  {
    't-layout--with-sider': settingStore.showSidebar,
  },
]);

const appendNewRoute = () => {
  const {
    path,
    query,
    meta: { title },
    name,
  } = route;
  tabsRouterStore.appendTabRouterList({ path, query, title: title as string, name, isAlive: true, meta: route.meta });
};

onMounted(() => {
  appendNewRoute();
});

watch(
  () => route.path,
  () => {
    appendNewRoute();
    document?.querySelector(`.${prefix}-layout`)?.scrollTo({ top: 0, behavior: 'smooth' });
  },
);
</script>

<style lang="less" scoped></style>
